function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var jumpTo = require(24);

// if (window.location.hash !== '') jumpTo($, window.location.hash);
module.exports = function () {
  if (window.location.hash !== '') {
    try {
      var hash = window.location.hash;
      var $hash = $(window.location.hash);
      if ($hash.length === 0) return;
      $hash.removeAttr('id');
      $(window).on('load', function () {
        $hash.attr('id', hash.slice(1));
        setTimeout(function () {
          jumpTo(hash);
        }, 1);
      });
    } catch (err) {
      if (_typeof(window.cabin) === 'object' && typeof window.cabin.warn === 'function') window.cabin.warn(err);else console.warn(err);
    }
  }
};
//# sourceMappingURL=handle-hash-on-load.js.map